"use strict";
'use client';
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.useTransitionTrigger = useTransitionTrigger;
var React = _interopRequireWildcard(require("react"));
/**
 * Allows child elements to be transitioned in and out.
 *
 * Demos:
 *
 * - [Transitions](https://mui.com/base-ui/react-transitions/#hooks)
 *
 * API:
 *
 * - [useTransitionTrigger API](https://mui.com/base-ui/react-transitions/hooks-api/#use-transition-trigger)
 */ function useTransitionTrigger(requestEnter) {
    var _React_useState = _sliced_to_array(React.useState(true), 2), exitTransitionFinished = _React_useState[0], setExitTransitionFinished = _React_useState[1];
    var hasPendingExitTransition = React.useRef(false);
    var registeredTransitions = React.useRef(0);
    var _React_useState1 = _sliced_to_array(React.useState(false), 2), hasTransition = _React_useState1[0], setHasTransition = _React_useState1[1];
    var previousRequestEnter = React.useRef(requestEnter);
    React.useEffect(function() {
        if (!requestEnter && // checking registeredTransitions.current instead of hasTransition to avoid this effect re-firing whenever hasTransition changes
        registeredTransitions.current > 0 && // prevents waiting for a pending transition right after mounting
        previousRequestEnter.current !== requestEnter) {
            hasPendingExitTransition.current = true;
            setExitTransitionFinished(false);
        }
        previousRequestEnter.current = requestEnter;
    }, [
        requestEnter
    ]);
    var handleExited = React.useCallback(function() {
        hasPendingExitTransition.current = false;
        setExitTransitionFinished(true);
    }, []);
    var registerTransition = React.useCallback(function() {
        registeredTransitions.current += 1;
        setHasTransition(true);
        return function() {
            registeredTransitions.current -= 1;
            if (registeredTransitions.current === 0) {
                setHasTransition(false);
            }
        };
    }, []);
    var hasExited;
    if (!hasTransition) {
        // If there are no transitions registered, the `exited` state is opposite of `requestEnter` immediately.
        hasExited = !requestEnter;
    } else if (requestEnter) {
        hasExited = false;
    } else {
        hasExited = !hasPendingExitTransition.current && exitTransitionFinished;
    }
    var contextValue = React.useMemo(function() {
        return {
            requestedEnter: requestEnter,
            onExited: handleExited,
            registerTransition: registerTransition,
            hasExited: hasExited
        };
    }, [
        handleExited,
        requestEnter,
        registerTransition,
        hasExited
    ]);
    return {
        contextValue: contextValue,
        hasExited: hasExited
    };
}
